class HomgPortfolioGalleryLightbox {
  constructor(section) {
    this.section = section;
    this.section.dataset.portfolioGalleryBound = 'true';
    this.modal = document.getElementById(section.dataset.portfolioGalleryModal);

    if (!this.modal) return;

    this.items = [...section.querySelectorAll('[data-portfolio-lightbox-trigger]')];
    this.image = this.modal.querySelector('.homg-portfolio-lightbox__image');
    this.link = this.modal.querySelector('[data-portfolio-lightbox-link]');
    this.count = this.modal.querySelector('[data-portfolio-lightbox-count]');
    this.prevButton = this.modal.querySelector('[data-portfolio-lightbox-prev]');
    this.nextButton = this.modal.querySelector('[data-portfolio-lightbox-next]');
    this.currentIndex = 0;
    this.lastWheelAt = 0;

    section.addEventListener('click', this.handleTriggerClick.bind(this));
    this.modal.addEventListener('click', this.handleModalClick.bind(this));
    this.modal.addEventListener('keydown', this.handleKeydown.bind(this));
    this.modal.addEventListener('wheel', this.handleWheel.bind(this), { passive: true });
  }

  handleTriggerClick(event) {
    const trigger = event.target.closest('[data-portfolio-lightbox-trigger]');
    if (!trigger) return;

    this.currentIndex = Number(trigger.dataset.portfolioIndex || 0);
    this.render();
  }

  handleModalClick(event) {
    if (event.target.closest('[data-portfolio-lightbox-prev]')) {
      this.showPrevious();
      return;
    }

    if (event.target.closest('[data-portfolio-lightbox-next]')) {
      this.showNext();
    }
  }

  handleKeydown(event) {
    if (!this.modal.hasAttribute('open')) return;

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.showPrevious();
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.showNext();
    }
  }

  handleWheel(event) {
    if (!this.modal.hasAttribute('open')) return;
    if (Math.abs(event.deltaY) < 18) return;

    const now = Date.now();
    if (now - this.lastWheelAt < 180) return;
    this.lastWheelAt = now;

    if (event.deltaY > 0) {
      this.showNext();
    } else {
      this.showPrevious();
    }
  }

  showPrevious() {
    if (!this.items.length) return;
    this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
    this.render();
  }

  showNext() {
    if (!this.items.length) return;
    this.currentIndex = (this.currentIndex + 1) % this.items.length;
    this.render();
  }

  render() {
    const item = this.items[this.currentIndex];
    if (!item) return;

    this.image.src = item.dataset.portfolioImageSrc || '';
    this.image.alt = item.dataset.portfolioImageAlt || '';
    this.image.setAttribute('width', item.dataset.portfolioImageWidth || '1');
    this.image.setAttribute('height', item.dataset.portfolioImageHeight || '1');
    this.count.textContent = `${this.currentIndex + 1} / ${this.items.length}`;

    if (item.dataset.portfolioLink) {
      this.link.href = item.dataset.portfolioLink;
      this.link.textContent = item.dataset.portfolioLinkLabel || 'View page';
      this.link.hidden = false;
    } else {
      this.link.removeAttribute('href');
      this.link.textContent = '';
      this.link.hidden = true;
    }

    const showNavigation = this.items.length > 1;
    this.prevButton.hidden = !showNavigation;
    this.nextButton.hidden = !showNavigation;
  }
}

document.querySelectorAll('[data-portfolio-gallery-section]').forEach((section) => {
  if (section.dataset.portfolioGalleryBound === 'true') return;
  new HomgPortfolioGalleryLightbox(section);
});
